import React from "react";
import {CoachliLogo} from "../../icons/CoachliLogo";
import {
  XIcon,
  SlackIcon,
  InstagramIcon,
  LinkedInIcon,
  FacebookIcon,
} from "../../icons/EmailPreviewSocialIcons";

interface EmailPreviewProps {
  subject: string;
  body: string;
  buttonText: string;
  addCustomButton: boolean;
}

export function EmailPreview({
  subject,
  body,
  buttonText,
  addCustomButton,
}: EmailPreviewProps) {
  return (
    <>
      <div
        style={{
          background: "#eae7f3",
          borderRadius: "12px",
          padding: "12px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            fontWeight: 700,
            color: "#1c1726",
            marginBottom: "16px",
          }}
        >
          {subject}
        </div>

        <div
          style={{fontSize: "14px", color: "#1c1726", lineHeight: 1.6}}
          dangerouslySetInnerHTML={{__html: body}} //TODO: sanitize html
        />

        {addCustomButton && buttonText && (
          <div style={{marginTop: "24px"}}>
            <button
              style={{
                background: "#1c1726",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "14px 28px",
                fontSize: "14px",
                fontWeight: 600,
                cursor: "default",
                width: "100%",
                maxWidth: "320px",
              }}
            >
              {buttonText}
            </button>
          </div>
        )}
        <div
          style={{
            background: "#fff",
            borderRadius: "12px",
            padding: "24px",
            marginTop: "24px",
            textAlign: "left",
          }}
        >
          <div
            style={{
              textAlign: "center",
            }}
          >
            <CoachliLogo />
          </div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: 400,
              color: "#1c1726",
              marginBottom: "4px",
            }}
          >
            Coachli
          </div>
          <div style={{fontSize: "14px", color: "#1c1726", marginBottom: "16px"}}>
            1233, 1007 N Orange St. 4th Floor, Wilmington, Delaware, USA.
          </div>

          <div style={{display: "flex", justifyContent: "center", gap: "12px"}}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F5F5F5",
              }}
            >
              <XIcon />
            </div>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F5F5F5",
              }}
            >
              <SlackIcon />
            </div>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F5F5F5",
              }}
            >
              <InstagramIcon />
            </div>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F5F5F5",
              }}
            >
              <LinkedInIcon />
            </div>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#F5F5F5",
              }}
            >
              <FacebookIcon />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
